export const vs30Tooltip =
  "Vs30 is the time-averaged shear wave velocity in top 30m beneath the site. Use a Vs30 value estimated for your site. The NSHM does not include a national Vs30 map.";

export const imtTooltip = `Intensity Measure Types (IMT) include Peak Ground Acceleration (PGA),
	 and Spectral Acceleration (SA) where bracketed values indicate the period in seconds.`;

export const poeTooltip = `The probability of experiencing an acceleration (g) or more within the next 50 years.
     Common values are 10% and 2% Probability of Exceedance (PoE) in 50 years.`;
